import { render, staticRenderFns } from "./business-child-auth.vue?vue&type=template&id=ff106d48&scoped=true&"
import script from "./business-child-auth.vue?vue&type=script&lang=js&"
export * from "./business-child-auth.vue?vue&type=script&lang=js&"
import style0 from "./business-child-auth.vue?vue&type=style&index=0&id=ff106d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff106d48",
  null
  
)

export default component.exports